/* RISK AND REWARD — theme scripts */
(function(){
  if (window.__rrInit) return; window.__rrInit = true;
  document.documentElement.classList.remove('no-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header: solid on scroll, mobile drawer ---------- */
  function initHeader(){
    var h = document.querySelector('.rr-header--overlay');
    if (h){
      var onS = function(){ h.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.55); };
      onS(); window.addEventListener('scroll', onS, {passive:true});
    }
    var d = document.querySelector('.rr-drawer');
    document.querySelectorAll('[data-rr-drawer]').forEach(function(b){
      b.addEventListener('click', function(){
        if(!d) return;
        var open = !d.classList.contains('is-open');
        d.classList.toggle('is-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
        document.querySelectorAll('[data-rr-drawer]').forEach(function(x){ x.setAttribute('aria-expanded', open); });
      });
    });
  }

  /* ---------- reveal ---------- */
  function initReveal(root){
    var els = (root||document).querySelectorAll('.rr-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target);} });
    }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- hero: wanted stars fill one by one ---------- */
  function initHero(root){
    (root||document).querySelectorAll('.rr-hero').forEach(function(hero){
      var stars = hero.querySelectorAll('.rr-wanted__star');
      var lvl = parseInt(hero.getAttribute('data-level') || stars.length, 10);
      stars.forEach(function(s,i){
        if (i >= lvl) return;
        if (reduce) { s.classList.add('is-on'); return; }
        setTimeout(function(){ s.classList.add('is-on'); }, 700 + i * 380);
      });
      var v = hero.querySelector('video');
      if (v){ v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    });
  }

  /* ---------- manifesto: words light up with scroll ---------- */
  function initManifesto(root){
    (root||document).querySelectorAll('[data-rr-words]').forEach(function(el){
      if (el.dataset.rrReady) return; el.dataset.rrReady = 1;
      var walk = function(node){
        Array.prototype.slice.call(node.childNodes).forEach(function(n){
          if (n.nodeType === 3){
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function(t){
              if (!t) return;
              if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
              var s = document.createElement('span'); s.className = 'w'; s.textContent = t; frag.appendChild(s);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) walk(n);
        });
      };
      walk(el);
      var words = el.querySelectorAll('.w');
      if (reduce){ words.forEach(function(w){ w.classList.add('is-lit'); }); return; }
      var tick = function(){
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * words.length);
        words.forEach(function(w,i){ w.classList.toggle('is-lit', i < n); });
      };
      tick(); window.addEventListener('scroll', tick, {passive:true}); window.addEventListener('resize', tick);
    });
  }

  /* ---------- lookbook: drag, arrows, progress, parallax ---------- */
  function initLook(root){
    (root||document).querySelectorAll('.rr-look').forEach(function(sec){
      var strip = sec.querySelector('.rr-look__strip'); if (!strip || strip.dataset.rrReady) return; strip.dataset.rrReady = 1;
      var bar = sec.querySelector('.rr-look__bar span');
      var items = strip.querySelectorAll('.rr-look__item');
      var speed = parseFloat(sec.getAttribute('data-parallax') || '0.22');
      var update = function(){
        var max = strip.scrollWidth - strip.clientWidth;
        if (bar) bar.style.width = (max > 0 ? Math.max(12, (strip.scrollLeft / max) * 100) : 100) + '%';
        if (reduce) return;
        var vh = window.innerHeight;
        items.forEach(function(it){
          var r = it.getBoundingClientRect(); var img = it.querySelector('img'); if(!img) return;
          var c = Math.max(-1, Math.min(1, (r.top + r.height/2 - vh/2) / vh));
          var cx = (r.left + r.width/2 - window.innerWidth/2) / window.innerWidth;
          img.style.setProperty('--py', (c * -60 * speed * 4) + 'px');
          img.style.transform = 'translate3d(' + (cx * -24 * speed * 4) + 'px,' + (c * -60 * speed * 4) + 'px,0)';
        });
      };
      strip.addEventListener('scroll', update, {passive:true});
      window.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update); update();
      var step = function(dir){
        var first = items[0]; if(!first) return;
        var gap = parseFloat(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap) || 20;
        strip.scrollBy({left: dir * (first.getBoundingClientRect().width + gap), behavior: reduce ? 'auto' : 'smooth'});
      };
      var prev = sec.querySelector('[data-rr-prev]'), next = sec.querySelector('[data-rr-next]');
      if (prev) prev.addEventListener('click', function(){ step(-1); });
      if (next) next.addEventListener('click', function(){ step(1); });
      /* mouse drag */
      var down = false, sx = 0, sl = 0, moved = false;
      strip.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = strip.scrollLeft; });
      window.addEventListener('pointermove', function(e){ if(!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4){ moved = true; strip.classList.add('is-drag'); } strip.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function(){ if(!down) return; down = false; strip.classList.remove('is-drag'); });
      strip.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- product form: size -> variant, ajax add ---------- */
  function money(cents){
    var fmt = (window.RR && RR.moneyFormat) || '€{{amount_with_comma_separator}}';
    var v = (cents/100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k.indexOf('comma') > -1) return v.replace('.', ',');
      if (k.indexOf('no_decimals') > -1) return Math.round(cents/100);
      return v;
    });
  }
  function toast(title){
    var t = document.querySelector('.rr-toast'); if(!t) return;
    t.querySelector('[data-rr-toast-title]').textContent = title;
    t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('is-on'); }, 4200);
  }
  function setCount(n){ document.querySelectorAll('.rr-cart-count').forEach(function(c){ c.textContent = n; c.setAttribute('data-count', n); }); }

  function initProduct(root){
    (root||document).querySelectorAll('[data-rr-product]').forEach(function(wrap){
      if (wrap.dataset.rrReady) return; wrap.dataset.rrReady = 1;
      var dataEl = wrap.querySelector('[data-rr-variants]'); if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-rr-add]');
      var priceEl = wrap.querySelector('[data-rr-price]');
      var cmpEl = wrap.querySelector('[data-rr-compare]');
      var stickyBtn = document.querySelector('[data-rr-sticky-add]');
      var stickyPrice = document.querySelector('[data-rr-sticky-price]');
      var chosen = function(){
        var o = [];
        wrap.querySelectorAll('[data-rr-option]').forEach(function(f, i){
          var c = f.querySelector('input:checked'); o[i] = c ? c.value : null;
        });
        return o;
      };
      var markAvail = function(){
        var opts = wrap.querySelectorAll('[data-rr-option]');
        opts.forEach(function(f, idx){
          f.querySelectorAll('input').forEach(function(inp){
            var cur = chosen(); cur[idx] = inp.value;
            var ok = variants.some(function(v){ return v.available && v.options.every(function(o,i){ return cur[i] == null || o === cur[i]; }); });
            var lab = inp.nextElementSibling; if (lab) lab.classList.toggle('is-out', !ok);
          });
        });
      };
      var apply = function(){
        var o = chosen();
        var v = variants.find(function(v){ return v.options.every(function(x,i){ return x === o[i]; }); });
        if (!v){ btn.disabled = true; btn.querySelector('span').textContent = btn.dataset.unavailable; return; }
        idInput.value = v.id;
        wrap.querySelectorAll('[data-rr-option]').forEach(function(f,i){ var sEl = f.querySelector('[data-rr-selected]'); if (sEl) sEl.textContent = v.options[i]; });
        if (priceEl) priceEl.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (cmpEl){ cmpEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
        if (stickyBtn) stickyBtn.disabled = !v.available;
        if (history.replaceState && wrap.hasAttribute('data-rr-url')){
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
        markAvail();
      };
      wrap.querySelectorAll('[data-rr-option] input').forEach(function(i){ i.addEventListener('change', apply); });
      markAvail();

      form.addEventListener('submit', function(e){
        if (!window.fetch) return;
        e.preventDefault();
        btn.disabled = true; var label = btn.querySelector('span'); var old = label.textContent; label.textContent = '…';
        fetch((window.RR && RR.root || '/') + 'cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)})
          .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
          .then(function(res){
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
            return fetch((window.RR && RR.root || '/') + 'cart.js').then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count); toast(res.j.product_title + (res.j.variant_title ? ' — ' + res.j.variant_title : '')); });
          })
          .catch(function(err){ alertInline(wrap, err.message); })
          .then(function(){ btn.disabled = false; label.textContent = old; });
      });
      if (stickyBtn){
        stickyBtn.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
        var sticky = document.querySelector('.rr-sticky-atc');
        if (sticky && 'IntersectionObserver' in window){
          new IntersectionObserver(function(en){ sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
        }
      }
      /* size guide */
      var sg = wrap.querySelector('[data-rr-sizeguide-open]'), dlg = document.getElementById('rr-sizeguide');
      if (sg && dlg && dlg.showModal){
        sg.addEventListener('click', function(){ dlg.showModal(); });
        dlg.addEventListener('click', function(e){ if (e.target === dlg || e.target.closest('[data-rr-close]')) dlg.close(); });
      }
      /* gallery dots (mobile) */
      var gal = wrap.querySelector('.rr-gallery'), dots = wrap.querySelectorAll('.rr-gallery__dots span');
      if (gal && dots.length){
        gal.addEventListener('scroll', function(){
          var i = Math.round(gal.scrollLeft / gal.clientWidth);
          dots.forEach(function(d,k){ d.classList.toggle('is-on', k === i); });
        }, {passive:true});
      }
    });
  }
  function alertInline(wrap, msg){
    var e = wrap.querySelector('[data-rr-error]'); if (!e) return;
    e.textContent = msg; e.hidden = false; setTimeout(function(){ e.hidden = true; }, 5000);
  }

  /* ---------- cart qty buttons ---------- */
  function initCart(){
    document.querySelectorAll('[data-rr-qty]').forEach(function(q){
      if (q.dataset.rrReady) return; q.dataset.rrReady = 1;
      var inp = q.querySelector('input');
      q.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          var v = Math.max(0, (parseInt(inp.value,10)||0) + parseInt(b.dataset.step,10));
          inp.value = v; inp.form.submit();
        });
      });
      inp.addEventListener('change', function(){ inp.form.submit(); });
    });
  }

  function all(root){ initReveal(root); initHero(root); initManifesto(root); initLook(root); initProduct(root); }
  document.addEventListener('DOMContentLoaded', function(){ initHeader(); initCart(); all(document); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();
